export default function getToolbarPreset(presetName) {
    // Toolbar button presets for combinations of buttons that are used more than once.
    // See documentation in Confluence for a table of which toolbar buttons can be used in which context:
    // https://dedact.atlassian.net/l/c/wqa65uqW
    switch (presetName) {
        case 'taskGroupsIntroduction':
            // Toolbar button set for task group introduction.
            return [
                'bold',
                'italic',
                'underline',
                'unorderedlist',
                'orderedlist',
                'outdent',
                'indent',
                'link',
                'table',
                'symbols',
                'expression',
                'subscript',
                'superscript',
                'source',
            ]
        case 'taskGroupsSource6Edit':
            // Toolbar button set for source 6 (Text with line numbers).
            return [
                'bold',
                'italic',
                'underline',
                'heading',
                'unorderedlist',
                'orderedlist',
                'image',
                'aside',
                'symbols',
                'subscript',
                'superscript',
                'source',
            ]
        case 'taskGroupSource12Edit':
            // Toolbar button set for source 12 (Text).
            return [
                'bold',
                'italic',
                'underline',
                'heading',
                'unorderedlist',
                'orderedlist',
                'outdent',
                'indent',
                'quote',
                'aside',
                'link',
                'image',
                'table',
                'column',
                'symbols',
                'expression',
                'subscript',
                'superscript'
            ]
        case 'taskGroupSource12EditTeacher':
            // Toolbar button set for source 12 (Text) as teacher.
            return [
                'bold',
                'italic',
                'underline',
                'heading',
                'unorderedlist',
                'orderedlist',
                'outdent',
                'indent',
                'quote',
                'aside',
                'link',
                'image',
                'table',
                'column',
                'symbols',
                'expression',
                'subscript',
                'superscript',
                'source',
                'simplify'
            ]
        case 'taskGroupsTemplate33Edit':
            // Toolbar button set for template 33 (Text selection).
            return [
                'bold',
                'italic',
                'underline',
                'heading',
                // TODO fix bad behavior lists in Template33.
                // 'unorderedlist',
                // 'orderedlist',
                'image',
                'symbols',
                'subscript',
                'superscript',
            ]
        case 'taskGroupsTemplate34Edit':
            // Toolbar button set for template 34 (Text order).
            return [
                'bold',
                'italic',
                'underline',
                'heading',
                'unorderedlist',
                'orderedlist',
                'outdent',
                'indent',
                'image',
                'symbols',
                'subscript',
                'superscript',
            ]
        case 'addToPlanner':
            // Toolbar button set for new item in planner.
            return [
                'bold',
                'italic',
                'underline',
                'unorderedlist',
                'orderedlist',
            ]
        case 'taskIntroduction':
            // Toolbar button set for task introduction.
            return [
                'italic',
                'underline',
                'unorderedlist',
                'orderedlist',
                'outdent',
                'indent',
                'link',
                'table',
                'symbols',
                'expression',
                'subscript',
                'superscript',
                'source',
            ]
        case 'taskExplanation':
            // Toolbar button set for task answer explanation.
            return [
                'bold',
                'italic',
                'underline',
                'unorderedlist',
                'orderedlist',
                'outdent',
                'indent',
                'link',
                'image',
                'table',
                'symbols',
                'expression',
                'subscript',
                'superscript',
                'source',
            ]
        case 'annotations':
            // Toolbar button set for annotation editor.
            return [
                'bold',
                'italic',
                'underline',
                'heading',
                'unorderedlist',
                'orderedlist',
                'outdent',
                'indent',
                'link',
                'image',
                'table',
                'symbols',
                'expression',
                'subscript',
                'superscript',
            ]
        case 'taskGroupsTemplate2Formatted':
            // Toolbar button set for template 2 (open question) with formatting allowed.
            return [
                'bold',
                'italic',
                'underline',
                'unorderedlist',
                'orderedlist',
                'outdent',
                'indent',
                'table',
            ]
        case 'taskGroupsTemplate2Equations':
            // Toolbar button set for template 2 (open question) with equations allowed.
            return [
                'expression',
                'subscript',
                'superscript',
                'symbols',
            ]
        case 'taskGroupsTemplate2All':
            // Toolbar preset for template 2 (open question) with both formatting and equation tools.
            return [
                'bold',
                'italic',
                'underline',
                'unorderedlist',
                'orderedlist',
                'outdent',
                'indent',
                'table',
                'expression',
                'subscript',
                'superscript',
                'symbols',
            ]
        case 'sendFeedback':
            // Toolbar button set for feedback.
            return [
                'bold',
                'italic',
                'underline',
                'unorderedlist',
                'orderedlist',
                'link',
                'table',
                'symbols',
                'subscript',
                'superscript',
            ]
        case 'studyPlanner':
            // Toolbar button set for study planner.
            return [
                'bold',
                'italic',
                'underline',
                'unorderedlist',
                'orderedlist',
                'link',
            ]
        case 'competenciesDescription':
            // Toolbar button set for the component description in a competencies activity
            return [
                'bold',
                'italic',
                'unorderedlist',
                'orderedlist',
                'outdent',
                'indent',
            ]
        default:
            if (presetName) {
                // Log in the event of an unknown toolbar preset name.
                window.sentry.withScope(scope => {
                    scope.setExtra('toolbar preset', presetName)
                    window.sentry.captureMessage('Unknown WYSIWYG toolbar preset name')
                })
            }
            return [
                'bold',
                'italic',
                'underline',
                'heading',
                'unorderedlist',
                'orderedlist',
                'outdent',
                'indent',
                'quote',
                'aside',
                'link',
                'image',
                'table',
                'column',
                'symbols',
                'expression',
                'subscript',
                'superscript',
                'source',
            ]
    }
}
